export const hexToRGBa = (hex: string, alpha?: number) => {
  let r: number | string = 0;
  let g: number | string = 0;
  let b: number | string = 0;

  // 3 digits #FFF
  if (hex.length === 4) {
    r = `0x${hex[1]}${hex[1]}`;
    g = `0x${hex[2]}${hex[2]}`;
    b = `0x${hex[3]}${hex[3]}`;

    // 6 digits #FFFFFF
  } else if (hex.length === 7) {
    r = `0x${hex[1]}${hex[2]}`;
    g = `0x${hex[3]}${hex[4]}`;
    b = `0x${hex[5]}${hex[6]}`;
  }

  return `rgba(${+r}, ${+g}, ${+b}, ${alpha || 0})`;
};

export function hslaToHex(input: string): string {
  const m = input
    .trim()
    .match(/^hsla?\(\s*([-\d.]+)(?:deg)?\s*[,\s]+\s*([-\d.]+)%\s*[,\s]+\s*([-\d.]+)%/i);
  if (!m) return '#000000';

  let h = parseFloat(m[1]);
  const s = Math.min(1, Math.max(0, parseFloat(m[2]) / 100));
  const l = Math.min(1, Math.max(0, parseFloat(m[3]) / 100));
  if (!Number.isFinite(h) || !Number.isFinite(s) || !Number.isFinite(l)) return '#000000';

  h = ((h % 360) + 360) % 360;

  const c = (1 - Math.abs(2 * l - 1)) * s;
  const hp = h / 60;
  const x = c * (1 - Math.abs((hp % 2) - 1));
  const m0 = l - c / 2;

  let r1 = 0;
  let g1 = 0;
  let b1 = 0;
  if (hp < 1) [r1, g1, b1] = [c, x, 0];
  else if (hp < 2) [r1, g1, b1] = [x, c, 0];
  else if (hp < 3) [r1, g1, b1] = [0, c, x];
  else if (hp < 4) [r1, g1, b1] = [0, x, c];
  else if (hp < 5) [r1, g1, b1] = [x, 0, c];
  else [r1, g1, b1] = [c, 0, x];

  const toByte = (v: number) => Math.max(0, Math.min(255, Math.round((v + m0) * 255)));
  const toHex = (n: number) => n.toString(16).padStart(2, '0').toUpperCase();

  return `#${toHex(toByte(r1))}${toHex(toByte(g1))}${toHex(toByte(b1))}`;
}
